import { Theme, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
	root: {
		"& .MuiDataGrid-row": {
			cursor: "pointer",
		},
		"& .MuiPaper-root ": {
			height: "100% !important",
		},
		"& .MuiDataGrid-columnHeaderTitle, & .MuiTablePagination-caption": {
			fontWeight: "bold",
		},
		"& .ag-icon-menu": {
			display: "none",
		},
		"& .ag-header-cell-label": {
			display: "flex",
			alignItems: "start",
			justifyContent: "start",
			fontSize: "0.85rem",
			fontWeight: "bold",
		},
		"& .ag-header-cell-centered .ag-header-cell-label": {
			justifyContent: "center !important",
		},

		"& .ag-header-cell-text": {
			textAlign: "start !important",
		},

		"& .ag-checkbox-input-wrapper": {
			margin: "0 10px",
		},
		"& .ag-cell": {
			padding: "2px !important",
		},
		"& .ag-header-cell": {
			padding: "0px !important",
			textAlign: "center !important",
			fontSize: 10,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		"& .ag-cell-wrapper": {},
		"& .ag-menu-option": {
			cursor: "pointer",
		},
	},
	card: {
		backgroundColor: "#eef2f6",
		borderRadius: 4,
		display: "flex",
		alignItems: "center",
		height: "100%",
		// justifyContent: "center",
	},
	filters: {
		position: "relative",
		margin: "0 10px",
	},
	form: {},
}));
